module.exports = __webpack_public_path__ + "static/media/Participant.2510305a.svg";